module.exports = __webpack_public_path__ + "img/qq.44496527.svg";